module.exports = __webpack_public_path__ + "static/media/IMG_3275.5e9bf9b7.JPG";